import { GetListsRequestDTO } from '@gearbelt/global';
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';
import { AWAApiV2Service } from '@/services/awa-api-v2';

export const listKeys = {
  all: ['lists'] as const,
  list: (limit: number) => [...listKeys.all, 'list', limit] as const,
  infinite: (search: string, orderBy?: GetListsRequestDTO['orderBy']) => [...listKeys.all, 'infinite', search, orderBy] as const,
};

export const listOptionsKeys = {
  all: ['list-options'] as const,
  byList: (listId: string, isAWA: boolean) => [...listOptionsKeys.all, 'list', listId, isAWA] as const,
};

export const getListsQueryOptions = ({ limit = 100 }: { limit?: number } = {}) => {
  return queryOptions({
    queryKey: listKeys.list(limit),
    queryFn: async () => (await (await ApiService.GetLists({ limit })).json()).data,
  });
};

export const getListsInfiniteQueryOptions = ({
  search,
  orderBy,
  enabled = true,
}: {
  search: string;
  orderBy?: GetListsRequestDTO['orderBy'];
  enabled?: boolean;
}) => {
  return infiniteQueryOptions({
    queryKey: listKeys.infinite(search, orderBy),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      await (
        await ApiService.GetLists({
          limit: 30,
          cursors: pageParam,
          filters: { search },
          orderBy,
        })
      ).json(),
    getNextPageParam: (lastPage) => (lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined),
    initialPageParam: undefined as string | undefined,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export const getListOptionsQueryOptions = ({ listId, isAWA = false }: { listId: string; isAWA?: boolean }) => {
  return queryOptions({
    queryKey: listOptionsKeys.byList(listId, isAWA),
    queryFn: async () => {
      const { list } = await (await (isAWA ? AWAApiV2Service : ApiService).GetListById(listId)).json();
      return list.elements;
    },
    enabled: !!listId,
  });
};
